<template>
  <div class="step-signature">
    <p class="step-desc text-center">
      Vui lòng sử dụng chữ ký thường dùng của bạn để hoàn tất xác nhận hợp đồng dịch vụ.
    </p>

    <div class="signature-area" ref="signatureArea">
      <SignaturePad
        ref="signaturePad"
        @changed="handleSignatureChanged"
        :width="1000"
        :height="1000"
        :style="{ opacity: hasDraw ? 1 : 0.4 }"
      />
      <div class="placeholder-signature" v-show="!hasDraw">
        <h5>Ký tại đây</h5>
        <p>Sử dụng chuột máy tính hoặc ngón tay để ký</p>
      </div>
    </div>

    <!-- Fake footer -->
    <div class="popup-footer">
      <b-button
        :disabled="!hasDraw"
        variant="outline-secondary"
        class="footer-btn"
        @click="handleReset"
      >
        Ký lại
      </b-button>
      <b-button :disabled="!hasDraw" variant="primary" class="footer-btn" @click="handleContinue">
        Tiếp tục
      </b-button>
    </div>
  </div>
</template>

<script>
  import SignaturePad from '@/components/SignaturePad.vue'
  import { uploadImg } from '@/services/contract.service'
  import { showMess } from '@/config/utils'
  // import { ContractService } from '@/services/contract.service'

  export default {
    name: 'StepSignature',
    components: { SignaturePad },
    props: {
      id: { type: String, required: true },
      token: { type: String, required: true },
      updateShowLoading: { type: Function, required: true },
    },
    data() {
      return {
        hasDraw: false,
        signatureWidth: 0,
        signatureHeight: 0,
      }
    },
    mounted() {
      this._resizeObserver = new ResizeObserver(() => {
        this.updateWidth()
      })
      this.$nextTick(() => {
        if (this.$refs.signatureArea) {
          this._resizeObserver.observe(this.$refs.signatureArea)
        }
      })
    },
    beforeDestroy() {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect()
      }
    },
    methods: {
      updateWidth() {
        const area = this.$refs.signatureArea
        if (area) {
          this.signatureWidth = area.clientWidth
          this.signatureHeight = area.clientHeight
        }
      },
      handleReset() {
        this.$refs.signaturePad.clear()
      },
      async handleContinue() {
        if (this.$refs.signaturePad.isEmpty()) {
          this.showFailMx('Vui lòng ký trước khi tiếp tục.')
          return
        }
        const file = await this.$refs.signaturePad.getFileNew(
          this.signatureWidth,
          this.signatureHeight
        )
        // upload AWS S3
        const signatureUrl = await this.uploadS3(file)
        // call api save
        if (signatureUrl) {
          // try {
          //   this.updateShowLoading(true)
          //   const res = await ContractService.actionAppendix({
          //     appendixId: this.id,
          //     appendixActionType: 'APPENDIX_ACTION_SIGN',
          //     signatures: [signatureUrl],
          //     isFromWeb: true,
          //   })
          //   if (res.code === 1000) {
          //     // if (res.result) {
          //     this.$emit('next-step')
          //   } else {
          //     showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 3000)
          //   }
          // } catch (error) {
          //   showMess(
          //     this,
          //     'Error',
          //     error.response?.data?.message || error.response?.message || error.message,
          //     'danger',
          //     'b-toaster-top-right',
          //     3000
          //   )
          // } finally {
          //   this.updateShowLoading(false)
          // }

          this.$emit('signature', signatureUrl)
          this.$emit('next-step')
        }
      },
      handleSignatureChanged(hasDraw) {
        this.hasDraw = hasDraw
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.updateShowLoading(true)
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrmNlContract')
            const res = await uploadImg(formData, this.token)
            if (res.code === 1000) {
              return res.data[0]
            } else {
              showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 3000)
              return null
            }
          }
        } catch (err) {
          showMess(
            this,
            'Error',
            err.response?.data?.message || err.response?.message || err.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.updateShowLoading(false)
        }
      },
    },
  }
</script>

<style scoped>
  .step-signature {
    display: flex;
    flex-direction: column;
  }

  .step-desc {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    margin-bottom: 16px;
  }

  .signature-area {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 260px;
    border: 1px dashed #008bf4;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
  }

  .placeholder-signature {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
    z-index: 0;
    width: 100%;
  }

  .placeholder-signature h5 {
    font-size: 24px;
    font-weight: 700;
    color: #999;
    margin-bottom: 8px;
  }

  .placeholder-signature p {
    font-size: 14px;
    color: #888;
    margin: 0;
    text-align: center;
  }

  /* Fake footer */
  .popup-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 0;
    border-top: 1px solid #e9ecef;
    margin-top: 20px;
  }

  .footer-btn {
    min-width: 100px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 20px;
  }
</style>
